import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.PageError', {
    errorText: 'Oops, the link you have followed is invalid.',
    errorDescription: 'You can see the requests awaiting your decision by opening Requires my approval folder.',
    goToRequiresMyDecision: 'GO TO REQUIRES MY APPROVAL',
    notFoundPage: 'Not found page',
});
